import {AxiosInstance} from 'axios'
import MyAxiosInstanceCoreAdmin from './axiosInstanceAdminCore'

// Auditoria (LCTO-1507): GET /admin/audit-events
export interface AuditEvent {
    event_id: string
    module: string | null
    entity: string | null
    entity_id: string | null
    operation: string | null
    before: Record<string, unknown> | null
    after: Record<string, unknown> | null
    user_uuid: string | null
    user_label: string | null
    org_uuid: string | null
    trace_id: string | null
    occurred_at: string | null
    received_at: string
}

export interface AuditEventFilters {
    entity?: string
    entity_id?: string
    operation?: string
    trace_id?: string
    occurred_from?: string
    occurred_to?: string
    skip?: number
    limit?: number
}

export class AdminCoreApi {
	private adminCoreApi: AxiosInstance
	constructor() {
		this.adminCoreApi = MyAxiosInstanceCoreAdmin
	}

	
    async getOrganizations(): Promise<any> {
        try {
            const res = await this.adminCoreApi.get('/organizations')
            return res.data
        } catch (error) {
            console.error('Erro ao obter organizações:', error)
            throw error
        }  
    }

    async getOrganizationsTier1(): Promise<any> {
        try {
            const res = await this.adminCoreApi.get('/organizations/?tier=1')
            return res.data
        } catch (error) {
            console.error('Erro ao obter organizações tier 1:', error)
            throw error
        }
    }

    // Lista pura, sem envelope nem total. Paginação por skip/limit.
    // Erro sobe para a página tratar por status (401/403/503).
    async listAuditEvents(filters: AuditEventFilters = {}): Promise<AuditEvent[]> {
        const {data} = await this.adminCoreApi.get('/audit-events', {params: filters})
        return data
    }
}
